<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @exceptionRegister="exceptionRegister"
      @packing="packing"
      @costReport="costReport"
      @backfill="backfill"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchIsPickUp="batchIsPickUp"
        @batchIsReceive="batchIsReceive"
        @batchDetailPrint="batchDetailPrint"
        @batchServiceFeedback="batchServiceFeedback"
        @batchExceptionRegister="batchExceptionRegister"
        @batchCostReport="batchCostReport"
        @batchExport="batchExport"
        @updateGoods="updateGoods"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <vxe-modal
      ref="abnormalRegistration"
      v-model="dialogOption.dialogVisible"
      :title="dialogOption.title"
      destroy-on-close
      type="modal"
      width="900"
      height="600"
    >
      <exception-register
        :registerData="registerData"
        :saveFlag="saveFlag"
        :paramsData="paramsData"
        @close="close"
        @reload="reload"
      />
    </vxe-modal>
    <!-- 客服反馈 -->
    <feedback-all
      v-if="feedbackVisible"
      :params="params"
      @feedbackClose="feedbackClose"
    />

    <!-- 特殊费用上报按钮 -->
    <el-dialog
      v-if="buttonDialogOption.costReportVisible"
      v-el-dialog-drag
      show-close
      width="1000px"
      visible
      :title="buttonDialogOption.title"
      :close-on-click-modal="false"
      :before-close="() => checkBoxClose()"
    >
      <fee-table-edit
        ref="feetableedit"
        :params="registerData"
        :codeData="codeData"
        :falg="falg"
        @reload="reload"
        @close="checkBoxClose"
      />
      <span slot="footer">
        <el-button @click="checkBoxClose()">取消</el-button>
        <el-button type="primary" @click="CheckBoxConfirm()">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-if="dialogOption.costReportVisible"
      v-el-dialog-drag
      show-close
      width="1000px"
      visible
      :title="dialogOption.title"
      :close-on-click-modal="false"
      :before-close="() => close()"
    >
      <fee-table-edit
        ref="feetableedit"
        :params="registerData"
        @reload="reload"
        @close="close"
      />
      <span slot="footer">
        <el-button @click="close()">取消</el-button>
        <el-button type="primary" @click="confirm()">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-if="dialogOption.packingVisible"
      v-el-dialog-drag
      show-close
      width="1000px"
      visible
      :title="dialogOption.title"
      :close-on-click-modal="false"
      :before-close="() => close()"
    >
      <packing-cooler
        ref="packing"
        :params="registerData"
        @reload="reload"
        @close="close"
      />
    </el-dialog>

    <Backfill
      :visible.sync="backfillDialogOption.visible"
      :title="backfillDialogOption.title"
      :waybillDetailCode="backfillDialogOption.code"
      @reload="reload"
    />
    <UpdateGoods
      :visible.sync="goodsDialogOption.visible"
      :title="goodsDialogOption.title"
      :waybillDetailCode="goodsDialogOption.waybillDetailCode"
      :custCode="goodsDialogOption.custCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import ExceptionRegister from '../exc-table/components/exception-register'
import FeeTableEdit from '../fee-table/components/fee-table-edit'
import FeedbackAll from '../feedback/feedback-all'
import PackingCooler from '../packing-table/packing-cooler'
import Backfill from '../backfill/dialog'
import UpdateGoods from '../update-goods/dialog'

export default {
  components: {
    PageMain,
    PageHeader,
    ExceptionRegister,
    FeeTableEdit,
    FeedbackAll,
    PackingCooler,
    Backfill,
    UpdateGoods,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      dialogOption: {
        title: '',
        dialogVisible: false,
        costReportVisible: false,
        packingVisible: false,
      },
      buttonDialogOption: {
        title: '',
        dialogVisible: false,
        costReportVisible: false,
      },
      feedbackVisible: false,
      registerData: {},
      paramsData: {},
      params: {},
      codeData: {},
      falg: 'A',
      saveFlag: '',
      updateGoodsStatusList: ['1', '2', '3', '4'],
      backfillDialogOption: {
        visible: false,
        title: '回填信息',
        code: '',
      },
      goodsDialogOption: {
        visible: false,
        title: '更新货物信息',
        waybillDetailCode: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .carriageWaybillDetailListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchIsPickUp() {
      this.$refs.main.batchIsPickup()
    },
    batchIsReceive() {
      this.$refs.main.batchIsReceive()
    },
    batchDetailPrint() {
      this.$refs.main.batchDetailPrint()
    },
    batchServiceFeedback() {
      const data = this.$refs.main.getTableCheckedData(true)
      if (data) {
        this.params = data
        this.feedbackVisible = true
      }
    },
    // 批量异常登记
    batchExceptionRegister() {
      const data = this.$refs.main.getTableCheckedData(true)
      if (data) {
        this.saveFlag = 'A'
        this.dialogOption.title = '异常登记'
        //this.registerData = data[0]
        this.paramsData = data
        this.dialogOption.dialogVisible = true
      } else {
        return
      }
    },
    exceptionRegister(row) {
      if (row) {
        this.dialogOption.title = '异常登记'
        this.registerData = row
        this.paramsData = []
        this.dialogOption.dialogVisible = true
      } else {
        return
      }
    },
    packing(row) {
      if (row) {
        this.dialogOption.title = '增加冷藏箱'
        this.registerData = row
        this.paramsData = []
        this.dialogOption.packingVisible = true
      } else {
        return
      }
    },

    costReport(row) {
      if (row) {
        this.dialogOption.title = '特殊费用'
        this.registerData = row
        this.dialogOption.costReportVisible = true
      } else {
        return
      }
    },
    batchCostReport() {
      const data = this.$refs.main.getTableCheckedData(true)
      if (!data) {
        return
      }
      this.codeData = data
      this.buttonDialogOption.title = '特殊费用上报'
      this.buttonDialogOption.costReportVisible = true
    },

    //数据回填
    backfill(row) {
      if (row) {
        this.backfillDialogOption = {
          visible: true,
          title: '数据回填',
          code: row.waybillDetailCode,
        }
      } else {
        return
      }
    },
    //货物信息
    updateGoods() {
      const data = this.$refs.main.getTableCheckedData(true)
      if (!data) return
      if (data.length > 1) {
        this.$message.warning('请选择一个订单进行更新！')
        return
      }
      const { waybillDetailCode, custCode, bizStatus, v_bizStatus } = data[0]
      if (this.updateGoodsStatusList.includes(bizStatus)) {
        this.goodsDialogOption = {
          visible: true,
          title: '更新货物信息',
          waybillDetailCode: waybillDetailCode,
          custCode: custCode,
        }
      } else {
        this.$message.warning(
          `当前单据状态为    ${v_bizStatus}   不能更新货物信息`
        )
      }
    },
    //特殊费用的保存方法
    confirm() {
      this.$refs.feetableedit
        .save()
        .then(() => {
          this.close()
        })
        .catch(() => {})
    },
    packingSave() {
      this.$refs.packing
        .save()
        .then(() => {
          this.close()
        })
        .catch(() => {})
    },
    CheckBoxConfirm() {
      this.$refs.feetableedit
        .boxSave()
        .then(() => {
          this.checkBoxClose()
        })
        .catch(() => {})
    },
    close() {
      this.dialogOption.dialogVisible = false
      this.dialogOption.costReportVisible = false
      this.dialogOption.packingVisible = false
    },
    feedbackClose() {
      this.feedbackVisible = false
    },
    checkBoxClose() {
      this.buttonDialogOption.dialogVisible = false
      this.buttonDialogOption.costReportVisible = false
    },
    batchExport() {
      this.$refs.main.batchExport()
    },
  },
}
</script>
